export default "__VITE_ASSET__BOYuYsoi__"